import { AttachmentFileType } from '@treetop/shared/model';

export function mapMimeTypeToAttachmentType(mimeType: string): AttachmentFileType {
  if (mimeType?.startsWith('image/')) {
    return AttachmentFileType.Image;
  }

  switch (mimeType) {
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return AttachmentFileType.Word;
    case 'application/pdf':
      return AttachmentFileType.PDF;
    default:
      return AttachmentFileType.Other;
  }
}
